/* eslint-disable @typescript-eslint/no-deprecated */

import React from 'react'
import styled, { useTheme } from 'styled-components'
import { SwipeableMenuContainer } from '../../../../buildingBlocks/SwipeableMenuContainer'
import { CloseIcon } from '../../../../buildingBlocks/SwipeableMenuContainer/CloseIcon'
import { SmallHeading } from '../../../../buildingBlocks/Typography'

interface Props {
  heading: string
  isOpen: boolean
  toggleOpen: () => void
}

export const MobileSearchMenu: React.FC<React.PropsWithChildren<Props>> = ({
  heading,
  isOpen,
  toggleOpen,
  children,
}) => {
  const theme = useTheme()

  return (
    <SwipeableMenuContainer
      backgroundColor={theme.colors.background.light}
      isOpen={isOpen}
      toggleOpen={toggleOpen}
      showCloseIcon={false}
    >
      <Container>
        <Header>
          <SmallHeading>{heading}</SmallHeading>
          <CloseIcon color={theme.colors.dark} onClick={toggleOpen} />
        </Header>
        {children}
      </Container>
    </SwipeableMenuContainer>
  )
}

const Container = styled.div`
  padding: 3rem 4rem;
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
